import { render, staticRenderFns } from "./CreateSubjectType.vue?vue&type=template&id=7937a7e8&scoped=true&lang=true&"
import script from "./CreateSubjectType.vue?vue&type=script&lang=js&"
export * from "./CreateSubjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7937a7e8",
  null
  
)

export default component.exports